import { SPECIALIST } from "../constants";
import { instance } from "../../axios";
import { store } from "../../store";

let getSpecialistsAction = () => {
  return (dispatch) => {
    dispatch({ type: SPECIALIST.GET_SPECIALISTS });
    instance
      .get(
        `/user/medecin?limit=${store.getState().specialist.limit}&offset=${
          store.getState().specialist.offset
        }&query=${encodeURI(store.getState().specialist.query)}`
      )
      .then((results) => {
        dispatch({ type: SPECIALIST.GET_SPECIALISTS_SUCCESS, payload: results.data });
      })
      .catch((error) => {
        dispatch({ type: SPECIALIST.GET_SPECIALISTS_FAILURE, payload: error });
      });
  };
};

let getSpecialistAction = (id) => {
  return (dispatch) => {
    dispatch({ type: SPECIALIST.GET_SPECIALIST });
    instance
      .get("/user/medecin/" + id)
      .then((results) => {
        dispatch({ type: SPECIALIST.GET_SPECIALIST_SUCCESS, payload: results.data });
      })
      .catch((error) => {
        dispatch({ type: SPECIALIST.GET_SPECIALIST_FAILURE, payload: error });
      });
  };
};

let createSpecialistAction = (body) => {
  return (dispatch) => {
    dispatch({ type: SPECIALIST.CREATE_SPECIALIST });
    instance
      .post("/user/medecin", body)
      .then((results) => {
        dispatch({ type: SPECIALIST.CREATE_SPECIALIST_SUCCESS, payload: results.data });
        dispatch(getSpecialistsAction());
      })
      .catch((error) => {
        dispatch({ type: SPECIALIST.CREATE_SPECIALIST_FAILURE, payload: error });
      });
  };
};

let updateSpecialistAction = (body) => {
  return (dispatch) => {
    dispatch({ type: SPECIALIST.UPDATE_SPECIALIST });
    instance
      .post("/user/medecin/" + body.id, body)
      .then((results) => {
        dispatch({ type: SPECIALIST.UPDATE_SPECIALIST_SUCCESS, payload: results.data });
        dispatch(getSpecialistsAction());
      })
      .catch((error) => {
        dispatch({ type: SPECIALIST.UPDATE_SPECIALIST_FAILURE, payload: error });
      });
  };
};

let deleteSpecialistAction = (id) => {
  return (dispatch) => {
    dispatch({ type: SPECIALIST.DELETE_SPECIALIST });
    instance
      .delete("/user/medecin/" + id)
      .then((results) => {
        dispatch({ type: SPECIALIST.DELETE_SPECIALIST_SUCCESS, payload: results.data });
        dispatch(getSpecialistsAction());
      })
      .catch((error) => {
        dispatch({ type: SPECIALIST.DELETE_SPECIALIST_FAILURE, payload: error });
      });
  };
};

let resetSpecialistPasswordAction = (id, password) => {
  return (dispatch) => {
    instance.post(`/user/medecin/${id}/password`, { password });
  };
};

let setOffset = (offset) => {
  return (dispatch) => {
    dispatch({ type: SPECIALIST.SET_OFFSET, payload: offset });
    dispatch(getSpecialistsAction());
  };
};

let setQuery = (query) => {
  return (dispatch) => {
    dispatch({ type: SPECIALIST.SET_QUERY, payload: query });
    dispatch(getSpecialistsAction());
  };
};

let cleanSpecialistAction = () => {
  return (dispatch) => {
    dispatch({ type: SPECIALIST.CLEAN_SPECIALIST });
  };
};

let updateSpecialistSignatureAction = (id, signature) => {
  return (dispatch) => {
    instance.post(`/user/medecin/${id}/signature`, { signature }).then(() => {
      dispatch(getSpecialistAction(id));
    });
  };
};

let addSpecialistAvailabilityAction = (specialistId, body) => {
  return (dispatch) => {
    dispatch({ type: SPECIALIST.ADD_AVAILABILITY });
    instance
      .post(`/user/medecin/${specialistId}/availability`, body)
      .then((results) => {
        dispatch({ type: SPECIALIST.ADD_AVAILABILITY_SUCCESS, payload: results.data });
      })
      .catch((error) => {
        dispatch({ type: SPECIALIST.ADD_AVAILABILITY_FAILURE, payload: error });
      });
  };
};

let deleteSpecialistAvailabilityAction = (specialistId, availId) => {
  return (dispatch) => {
    dispatch({ type: SPECIALIST.DELETE_AVAILABILITY });
    instance
      .delete(`/user/medecin/${specialistId}/availability/${availId}`)
      .then((results) => {
        dispatch({ type: SPECIALIST.DELETE_AVAILABILITY_SUCCESS, payload: results.data });
      })
      .catch((error) => {
        dispatch({ type: SPECIALIST.DELETE_AVAILABILITY_FAILURE, payload: error });
      });
  };
};

export {
  getSpecialistsAction,
  getSpecialistAction,
  createSpecialistAction,
  updateSpecialistAction,
  deleteSpecialistAction,
  resetSpecialistPasswordAction,
  updateSpecialistSignatureAction,
  setOffset,
  setQuery,
  cleanSpecialistAction,
  addSpecialistAvailabilityAction,
  deleteSpecialistAvailabilityAction,
};
